/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weak_Signal_QualityInputs */



/**
* | output |
* | --- |
* | "Weak signal quality" |
*
* @param {Weak_Signal_QualityInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const weak_signal_quality = /** @type {((inputs?: Weak_Signal_QualityInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weak_Signal_QualityInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Weak signal quality")
	return /** @type {LocalizedString} */ ("Qualité du signal faible")
});